import React from 'react';
import './BadgesAwardedPrompt.css'; // Importing the CSS file below

const BadgesAwardedPrompt = ({ badgesAwarded = [] }) => {
  const badgeCount = badgesAwarded.length;

  if (badgeCount === 0) return null;

  return (
    <div className="badge-prompt-container">
      {/* Top Gradient Accent Bar */}
      <div className="badge-prompt-accent" />
      
      <div className="badge-prompt-content">
        {/* Achievement Icon Header */}
        <div className="badge-prompt-icon">🎉</div>
        
        <p className="badge-prompt-subtitle">
          You have earned <span className="badge-count-highlight">{badgeCount}</span> new {badgeCount === 1 ? 'badge' : 'badges'}!
        </p>

        {/* Badges Display Flex */}
        <div className="badge-list">
          {badgesAwarded.map((badge, index) => (
            <div key={index} className="badge-card">
              <img 
                src={badge.imageUrl} 
                alt={badge.name} 
                className="badge-image"
              />
              <span className="badge-name" title={badge.name}>
                {badge.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BadgesAwardedPrompt;